import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Params } from '@angular/router';
import {
  ApiFilter,
  ApiFiltergruppe,
  ApiFiltergruppenfilter,
  FilterClient,
  FiltergruppeClient,
} from '@api/AffinisDIDApiClient';
import { SearchAttributeInfo, SearchFilterEntity } from 'app/interfaces/searchfilter-entity';
import { BehaviorSubject, Observable, Subject, Subscription } from 'rxjs';
import { KfmaoCode } from './kfmaoCode';

@Injectable({
  providedIn: 'root',
})
export class DashboardService {
  diagram_structure = [
    {
      pos_x: 50,
      pos_y: 10,
    },
    {
      pos_x: 20,
      pos_y: 80,
    },
    {
      pos_x: 20,
      pos_y: 140,
    },
    {
      pos_x: 50,
      pos_y: 210,
    },
    {
      pos_x: 420,
      pos_y: 10,
    },
    {
      pos_x: 450,
      pos_y: 80,
    },
    {
      pos_x: 450,
      pos_y: 140,
    },
    {
      pos_x: 420,
      pos_y: 210,
    },
    {
      pos_x: 235,
      pos_y: 275,
    },
  ];

  subscriptions: Subscription[] = [];

  searchFilterGroupIdSelected = '';

  gefmaOrKfmaoCodeSelected = '';

  /*
   * Enthält alle ApiFiltergruppen, die über den Client geladen worden sind
   */
  public allApiFiltergruppenSubject = new BehaviorSubject<ApiFiltergruppe[]>([]);

  /*
   * Enthält alle ApiFilter, die über den Client geladen worden sind
   */
  public allApiFilter: ApiFilter[] = [];

  /*
   * Enthält alle ApiFiltergruppenFilter, die über den Client geladen worden sind
   */
  searchAttributes: ApiFiltergruppenfilter[] = [];

  /*
   * Enthält die Daten, die der Nutzer in der UI in die jeweiligen Filter-Elemente eingegeben hat.
   */
  searchAttributesInfo: SearchAttributeInfo[] = [];

  /*
   * Enthält zusätzliche Daten für Suchfilter, die in der UI nicht dargestellt werden.
   */
  hiddenSearchAttributes: SearchAttributeInfo[] = [];

  public searchFilterEntites: SearchFilterEntity[] = [];

  public searchFilterSubject = new BehaviorSubject<SearchFilterEntity[]>([]);

  public title$ = new BehaviorSubject<string>('');

  public startSearch = new Subject<boolean>();

  public documentGroupSubject = new BehaviorSubject<string>('');

  public filterWertIdSubgject = new BehaviorSubject<string>('');

  public weParamSubject = new Subject<string>();

  public searchFilterType = -1;

  public searchLocationId = '';

  public queryParams: Params = {};

  // TODO: Sollte eigentlich über die API geladen werden. Funktioniert nur nicht,
  // wenn der Nutzer nicht angemeldet ist, bzw. während die Authentifizierung läuft.
  // Da die Daten im Anwendungsfall unveränderlich sind, wurde eine statische Liste
  // der bekannten Code-Kombinationen erstellt.
  public kfmaoCodes = [
    new KfmaoCode(1, null, null, null, 'Grundstück'),
    new KfmaoCode(1, 1, null, null, 'Übersicht  Wirtschaftseinheit'),
    new KfmaoCode(1, 1, 1, null, 'Kurzzusammenstellung'),
    new KfmaoCode(1, 1, 2, null, 'Lageplan mit Bauteilbezeichnung ( Bauteilnummern )'),
    new KfmaoCode(1, 2, null, null, 'Rechtliche Verhältnisse '),
    new KfmaoCode(1, 2, 1, null, 'Eigentumsverhältnisse'),
    new KfmaoCode(1, 2, 1, 1, 'Aktueller Grundbuchauszug mit Bestandsverzeichnis'),
    new KfmaoCode(1, 2, 1, 2, 'Veränderungsnachweise'),
    new KfmaoCode(1, 2, 1, 3, 'Eintragungsbewilligungen, Lasten und Beschränkungen'),
    new KfmaoCode(1, 2, 1, 4, 'Rechtsträgernachweis (Neue Bundesländer)'),
    new KfmaoCode(1, 2, 1, 5, 'Vermögenszuordnungsbescheid (Neue Bundesländer)'),
    new KfmaoCode(1, 2, 1, 6, 'Restitutionsansprüche (Neue Bundesländer)'),
    new KfmaoCode(1, 2, 1, 7, 'Subventionen / Vergünstigungen'),
    new KfmaoCode(1, 2, 2, null, 'Verträge'),
    new KfmaoCode(1, 2, 2, 1, 'Grundstückskaufverträge'),
    new KfmaoCode(1, 2, 2, 2, 'Erbbaurechtsverträge'),
    new KfmaoCode(1, 2, 2, 3, 'Verwaltungsvereinbarung'),
    new KfmaoCode(1, 2, 2, 4, 'vorläufige Verwaltungsvereinbarung'),
    new KfmaoCode(1, 2, 2, 5, 'Teilungserklärung'),
    new KfmaoCode(1, 2, 2, 6, 'Schriftverkehr'),
    new KfmaoCode(
      1,
      2,
      3,
      null,
      'Grund- / Dienstbarkeiten / Nicht grundbuchlich gesicherte Rechte'
    ),
    new KfmaoCode(1, 2, 3, 1, 'Vorkaufs- / Ankaufsrechte'),
    new KfmaoCode(1, 2, 3, 2, 'Wege- und Fahrrechte'),
    new KfmaoCode(1, 2, 3, 3, 'Leitungsrechte'),
    new KfmaoCode(1, 2, 3, 4, 'Aussichtsrechte'),
    new KfmaoCode(1, 2, 3, 5, 'Wohnrecht /  Wohnungsrechte'),
    new KfmaoCode(1, 2, 3, 6, 'Schuldurkunden'),
    new KfmaoCode(1, 2, 3, 7, 'Sonstige Grund- / Dienstbarkeiten'),
    new KfmaoCode(1, 2, 3, 8, 'Nicht grundbuchlich gesicherte Rechte'),
    new KfmaoCode(1, 2, 3, 9, 'Schriftverkehr'),
    new KfmaoCode(1, 2, 4, null, 'Amtliche Unterlagen / Pläne / Baurecht'),
    new KfmaoCode(1, 2, 4, 1, 'Flurkarte / Lageplan / Katasterplan'),
    new KfmaoCode(1, 2, 4, 2, 'Raumordnungsverfahren (soweit vorhanden)'),
    new KfmaoCode(1, 2, 4, 3, 'Entwicklungsplan (soweit vorhanden)'),
    new KfmaoCode(1, 2, 4, 4, 'Bebauungsplan '),
    new KfmaoCode(1, 2, 4, 5, 'Flächennutzungsplan '),
    new KfmaoCode(1, 2, 4, 6, 'Bodenrichtwertkarte'),
    new KfmaoCode(1, 2, 4, 7, 'Abmarkungsbescheid'),
    new KfmaoCode(1, 2, 4, 8, 'Schriftverkehr'),
    new KfmaoCode(1, 2, 4, 9, 'Bauleitplanung'),
    new KfmaoCode(1, 2, 5, null, 'Amtliche Unterlagen / Steuern'),
    new KfmaoCode(1, 2, 5, 1, 'Grundsteuer-/ Einheitswert-/ Grundsteuermessbescheid '),
    new KfmaoCode(1, 2, 6, null, 'Baulastenverzeichnis zzgl. Schuldrechtliche Vereinbarungen'),
    new KfmaoCode(1, 3, null, null, 'Nachbarn '),
    new KfmaoCode(1, 3, 1, null, 'Bekannte Nachbaransprüche / Rechtstreite'),
    new KfmaoCode(1, 3, 2, null, 'Nachbarrechtlichen Vereinbarungen'),
    new KfmaoCode(1, 4, null, null, 'Öffentliche Erschließung'),
    new KfmaoCode(1, 4, 1, null, 'Erschließungsstatus'),
    new KfmaoCode(1, 4, 2, null, 'Erschließungsbeiträge'),
    new KfmaoCode(1, 5, null, null, 'Boden- und Baugrundgutachten'),
    new KfmaoCode(1, 6, null, null, 'Verkauf / Abtretung'),
    new KfmaoCode(1, 6, 1, null, 'verkaufte Objekte'),
    new KfmaoCode(1, 6, 2, null, 'Teilverkauf'),
    new KfmaoCode(1, 6, 3, null, 'Straßenlandabtretung/ Grundstücksabtretung'),
    new KfmaoCode(1, 7, null, null, 'Sonstiges'),
    new KfmaoCode(2, null, null, null, 'Baulicher Bestand'),
    new KfmaoCode(2, 1, null, null, 'Übersicht baulicher Bestand / Gebäudedaten'),
    new KfmaoCode(2, 1, 1, null, 'Nutzungsart'),
    new KfmaoCode(2, 1, 2, null, 'Objekttyp'),
    new KfmaoCode(2, 1, 3, null, 'Bauwerksindex'),
    new KfmaoCode(2, 1, 4, null, 'Baujahr'),
    new KfmaoCode(2, 10, null, null, 'Bestandspläne (soweit nicht in LIAS)'),
    new KfmaoCode(2, 11, null, null, 'Spartenpläne (soweit nicht in LIAS)'),
    new KfmaoCode(2, 11, 1, null, 'Kabelleitungsplan Grundstück'),
    new KfmaoCode(2, 11, 2, null, 'Leitungspläne ( Strom, Gas, Wasser)'),
    new KfmaoCode(2, 12, null, null, 'Bauunterhalt / Investition / Versicherungen'),
    new KfmaoCode(
      2,
      12,
      1,
      null,
      'Baubegehungsprotokolle / Maßnahmenbeschreibungen / Instandhaltungsplan'
    ),
    new KfmaoCode(2, 12, 2, null, 'Gewährleistungsfristen für Gebäude'),
    new KfmaoCode(2, 13, null, null, 'Versicherungen'),
    new KfmaoCode(2, 14, null, null, 'Überwachungspflichtige Anlagen'),
    new KfmaoCode(2, 15, null, null, 'Sonstiges'),
    new KfmaoCode(2, 2, null, null, 'Amtliche Unterlagen / Baurecht'),
    new KfmaoCode(2, 2, 1, null, 'Bauanträge /  Baugenehmigungen / Zustimmungsbescheide'),
    new KfmaoCode(2, 2, 2, null, 'Sonstige öffentlich rechtliche Beschränkungen'),
    new KfmaoCode(2, 2, 2, 1, 'Veränderungssperren'),
    new KfmaoCode(2, 2, 2, 2, 'Naturschutzauflagen'),
    new KfmaoCode(2, 2, 2, 3, 'Erhaltungssatzung'),
    new KfmaoCode(2, 2, 2, 4, 'Sanierungssatzung'),
    new KfmaoCode(2, 2, 3, null, 'Bau- und Ausstattungsbeschreibungen'),
    new KfmaoCode(2, 3, null, null, 'Statik / Prüfstatik'),
    new KfmaoCode(2, 3, 1, null, 'Statische Berechnungen'),
    new KfmaoCode(2, 3, 2, null, 'Bewehrungsplanung '),
    new KfmaoCode(2, 3, 3, null, 'Schalplanung'),
    new KfmaoCode(2, 4, null, null, 'Sonstige Gutachten / Berechnungen'),
    new KfmaoCode(2, 4, 1, null, 'Schallschutz'),
    new KfmaoCode(2, 4, 2, null, 'Wärmeschutz'),
    new KfmaoCode(2, 4, 3, null, 'Brandschutz'),
    new KfmaoCode(2, 4, 4, null, 'Beweissicherung'),
    new KfmaoCode(2, 4, 5, null, 'Verkehrswertermittlung'),
    new KfmaoCode(2, 4, 6, null, 'Weitere Gutachten'),
    new KfmaoCode(2, 5, null, null, 'Denkmalschutz'),
    new KfmaoCode(2, 6, null, null, 'Kunst am Bau'),
    new KfmaoCode(2, 7, null, null, 'Fotos'),
    new KfmaoCode(
      2,
      8,
      null,
      null,
      'Architektenvertrag / Urheberrechte / ggfs. Übertragung von Nutzungsrechten'
    ),
    new KfmaoCode(2, 9, null, null, 'Flächen- und Kubaturberechnungen'),
    new KfmaoCode(2, 9, 1, null, 'Flächen-und Kubaturberechnungen'),
    new KfmaoCode(2, 9, 2, null, 'GRZ  /GFZ / BMZ-Berechnungen'),
    new KfmaoCode(3, null, null, null, 'Altlasten / Umweltrisiken'),
    new KfmaoCode(3, 1, null, null, 'Altlasten Boden'),
    new KfmaoCode(3, 1, 1, null, 'Altlastengutachten '),
    new KfmaoCode(3, 1, 2, null, 'Entsorgungsnachweis'),
    new KfmaoCode(3, 1, 3, null, 'Status Dekontaminierungsmaßnahmen'),
    new KfmaoCode(3, 1, 4, null, 'Kosten der Dekontaminierung'),
    new KfmaoCode(3, 2, null, null, 'Altlasten Gebäude'),
    new KfmaoCode(3, 2, 1, null, 'Asbest'),
    new KfmaoCode(3, 2, 1, 1, 'Altlastengutachten '),
    new KfmaoCode(3, 2, 1, 2, 'Entsorgungsnachweis'),
    new KfmaoCode(3, 2, 1, 3, 'Status Dekontaminierungsmaßnahmen'),
    new KfmaoCode(3, 2, 1, 4, 'Kosten der Dekontaminierung'),
    new KfmaoCode(3, 2, 2, null, 'PCB'),
    new KfmaoCode(3, 2, 2, 1, 'Altlastengutachten '),
    new KfmaoCode(3, 2, 2, 2, 'Entsorgungsnachweis'),
    new KfmaoCode(3, 2, 2, 3, 'Status Dekontaminierungsmaßnahmen'),
    new KfmaoCode(3, 2, 2, 4, 'Kosten der Dekontaminierung'),
    new KfmaoCode(3, 2, 3, null, 'Sonstiges'),
    new KfmaoCode(3, 2, 3, 1, 'Altlastengutachten '),
    new KfmaoCode(3, 2, 3, 2, 'Entsorgungsnachweis'),
    new KfmaoCode(3, 2, 3, 3, 'Status Dekontaminierungsmaßnahmen'),
    new KfmaoCode(3, 2, 3, 4, 'Kosten der Dekontaminierung'),
    new KfmaoCode(3, 3, null, null, 'Altlastenverdachtsfläche'),
    new KfmaoCode(3, 3, 1, null, 'Boden'),
    new KfmaoCode(3, 3, 2, null, 'Gebäude'),
    new KfmaoCode(3, 4, null, null, 'Vergangenheit des Grundstücks'),
    new KfmaoCode(3, 4, 1, null, 'Boden'),
    new KfmaoCode(3, 4, 2, null, 'Gebäude'),
    new KfmaoCode(3, 5, null, null, 'Behördliche Anordnungen'),
    new KfmaoCode(3, 5, 1, null, 'Boden'),
    new KfmaoCode(3, 5, 2, null, 'Gebäude'),
    new KfmaoCode(3, 6, null, null, 'Sanierungsplan'),
    new KfmaoCode(3, 6, 1, null, 'Boden'),
    new KfmaoCode(3, 6, 2, null, 'Gebäude'),
    new KfmaoCode(3, 7, null, null, 'Sonstiges'),
    new KfmaoCode(4, null, null, null, 'Anmietung'),
    new KfmaoCode(4, 1, null, null, 'Übersicht'),
    new KfmaoCode(4, 2, null, null, 'Anmietverträge'),
    new KfmaoCode(4, 2, 1, null, 'Mietvertrag  '),
    new KfmaoCode(4, 2, 2, null, 'Anlagen Mietvertrag '),
    new KfmaoCode(4, 2, 3, null, 'Nachträge Mietvertrag'),
    new KfmaoCode(4, 2, 4, null, 'Übergabeprotokoll'),
    new KfmaoCode(4, 2, 5, null, 'Umbauten / Rückbauverpflichtungen'),
    new KfmaoCode(
      4,
      2,
      6,
      null,
      'Betriebskostenabrechnungen ggfs. inkl. rechnungsbegründete Unterlagen'
    ),
    new KfmaoCode(4, 2, 7, null, 'vertragsrelevanter Schriftverkehr '),
    new KfmaoCode(4, 3, null, null, 'Pachtverträge'),
    new KfmaoCode(4, 3, 1, null, 'Pachtvertrag  '),
    new KfmaoCode(4, 3, 2, null, 'Anlagen Pachtvertrag '),
    new KfmaoCode(4, 3, 3, null, 'Nachträge Pachtvertrag'),
    new KfmaoCode(4, 3, 4, null, 'Übergabeprotokoll'),
    new KfmaoCode(4, 3, 5, null, 'Umbauten / Rückbauverpflichtungen'),
    new KfmaoCode(
      4,
      3,
      6,
      null,
      'Betriebskostenabrechnungen ggfs. inkl. rechnungsbegründete Unterlagen'
    ),
    new KfmaoCode(4, 3, 7, null, 'vertragsrelevanter Schriftverkehr '),
    new KfmaoCode(4, 4, null, null, 'Gestattungsverträge'),
    new KfmaoCode(4, 4, 1, null, 'Gestattungsvertrag  '),
    new KfmaoCode(4, 4, 2, null, 'Anlagen Gestattungsvertrag '),
    new KfmaoCode(4, 4, 3, null, 'Nachträge Gestattungsvertrag'),
    new KfmaoCode(4, 4, 4, null, 'Übergabeprotokoll'),
    new KfmaoCode(4, 4, 5, null, 'Umbauten / Rückbauverpflichtungen'),
    new KfmaoCode(
      4,
      4,
      6,
      null,
      'Betriebskostenabrechnungen ggfs. inkl. rechnungsbegründete Unterlagen'
    ),
    new KfmaoCode(4, 4, 7, null, 'vertragsrelevanter Schriftverkehr '),
    new KfmaoCode(4, 5, null, null, 'Leasingverträge'),
    new KfmaoCode(4, 5, 1, null, 'Leasingvertrag  '),
    new KfmaoCode(4, 5, 2, null, 'Anlagen Leasingvertrag '),
    new KfmaoCode(4, 5, 3, null, 'Nachträge Leasingvertrag'),
    new KfmaoCode(4, 5, 4, null, 'Übergabeprotokoll'),
    new KfmaoCode(4, 5, 5, null, 'Umbauten / Rückbauverpflichtungen'),
    new KfmaoCode(
      4,
      5,
      6,
      null,
      'Betriebskostenabrechnungen ggfs. inkl. rechnungsbegründete Unterlagen'
    ),
    new KfmaoCode(4, 5, 7, null, 'vertragsrelevanter Schriftverkehr '),
    new KfmaoCode(4, 6, null, null, 'Nutzungsüberlassungsverträge'),
    new KfmaoCode(4, 6, 1, null, 'Nutzungsüberlassungsvertrag  '),
    new KfmaoCode(4, 6, 2, null, 'Anlagen Nutzungsüberlassungsvertrag '),
    new KfmaoCode(4, 6, 3, null, 'Nachträge Nutzungsüberlassungsvertrag'),
    new KfmaoCode(4, 6, 4, null, 'Übergabeprotokoll'),
    new KfmaoCode(4, 6, 5, null, 'Umbauten / Rückbauverpflichtungen'),
    new KfmaoCode(
      4,
      6,
      6,
      null,
      'Betriebskostenabrechnungen ggfs. inkl. rechnungsbegründete Unterlagen'
    ),
    new KfmaoCode(4, 6, 7, null, 'vertragsrelevanter Schriftverkehr '),
    new KfmaoCode(4, 7, null, null, 'Beendete Mietverträge'),
    new KfmaoCode(5, null, null, null, 'Vermietung'),
    new KfmaoCode(5, 1, null, null, 'Übersicht'),
    new KfmaoCode(5, 2, null, null, 'Vermietverträge'),
    new KfmaoCode(5, 2, 1, null, 'Mietvertrag'),
    new KfmaoCode(5, 2, 2, null, 'Anlagen Mietvertrag '),
    new KfmaoCode(5, 2, 3, null, 'Nachträge Mietvertrag'),
    new KfmaoCode(5, 2, 4, null, 'Übergabeprotokoll'),
    new KfmaoCode(5, 2, 5, null, 'Umbauten / Rückbauverpflichtungen'),
    new KfmaoCode(
      5,
      2,
      6,
      null,
      'Betriebskostenabrechnungen ggfs. inkl. rechnungsbegründete Unterlagen'
    ),
    new KfmaoCode(5, 2, 7, null, 'vertragsrelevanter Schriftverkehr '),
    new KfmaoCode(5, 3, null, null, 'Pachtverträge'),
    new KfmaoCode(5, 3, 1, null, 'Pachtvertrag  '),
    new KfmaoCode(5, 3, 2, null, 'Anlagen Pachtvertrag '),
    new KfmaoCode(5, 3, 3, null, 'Nachträge Pachtvertrag'),
    new KfmaoCode(5, 3, 4, null, 'Übergabeprotokoll'),
    new KfmaoCode(5, 3, 5, null, 'Umbauten / Rückbauverpflichtungen'),
    new KfmaoCode(
      5,
      3,
      6,
      null,
      'Betriebskostenabrechnungen ggfs. inkl. rechnungsbegründete Unterlagen'
    ),
    new KfmaoCode(5, 3, 7, null, 'vertragsrelevanter Schriftverkehr '),
    new KfmaoCode(5, 4, null, null, 'Gestattungsverträge'),
    new KfmaoCode(5, 4, 1, null, 'Gestattungsvertrag  '),
    new KfmaoCode(5, 4, 2, null, 'Anlagen Gestattungsvertrag '),
    new KfmaoCode(5, 4, 3, null, 'Nachträge Gestattungsvertrag'),
    new KfmaoCode(5, 4, 4, null, 'Übergabeprotokoll'),
    new KfmaoCode(5, 4, 5, null, 'Umbauten / Rückbauverpflichtungen'),
    new KfmaoCode(
      5,
      4,
      6,
      null,
      'Betriebskostenabrechnungen ggfs. inkl. rechnungsbegründete Unterlagen'
    ),
    new KfmaoCode(5, 4, 7, null, 'vertragsrelevanter Schriftverkehr '),
    new KfmaoCode(5, 5, null, null, 'Leasingverträge'),
    new KfmaoCode(5, 5, 1, null, 'Leasingvertrag  '),
    new KfmaoCode(5, 5, 2, null, 'Anlagen Leasingvertrag '),
    new KfmaoCode(5, 5, 3, null, 'Nachträge Leasingvertrag'),
    new KfmaoCode(5, 5, 4, null, 'Übergabeprotokoll'),
    new KfmaoCode(5, 5, 5, null, 'Umbauten / Rückbauverpflichtungen'),
    new KfmaoCode(
      5,
      5,
      6,
      null,
      'Betriebskostenabrechnungen ggfs. inkl. rechnungsbegründete Unterlagen'
    ),
    new KfmaoCode(5, 5, 7, null, 'vertragsrelevanter Schriftverkehr '),
    new KfmaoCode(5, 6, null, null, 'Nutzungsüberlassungsverträge'),
    new KfmaoCode(5, 6, 1, null, 'Nutzungsüberlassungsvertrag  '),
    new KfmaoCode(5, 6, 2, null, 'Anlagen Nutzungsüberlassungsvertrag '),
    new KfmaoCode(5, 6, 3, null, 'Nachträge Nutzungsüberlassungsvertrag'),
    new KfmaoCode(5, 6, 4, null, 'Übergabeprotokoll'),
    new KfmaoCode(5, 6, 5, null, 'Umbauten / Rückbauverpflichtungen'),
    new KfmaoCode(
      5,
      6,
      6,
      null,
      'Betriebskostenabrechnungen ggfs. inkl. rechnungsbegründete Unterlagen'
    ),
    new KfmaoCode(5, 6, 7, null, 'vertragsrelevanter Schriftverkehr '),
    new KfmaoCode(5, 7, null, null, 'Betriebskosten nach II.BV'),
    new KfmaoCode(5, 8, null, null, 'Aufstellung der nicht umlegbaren Nebenkosten'),
    new KfmaoCode(5, 9, null, null, 'Beendete Vermietverträge'),
    new KfmaoCode(6, null, null, null, 'Betreiben'),
    new KfmaoCode(6, 1, null, null, 'Objektbetrieb         '),
    new KfmaoCode(6, 1, 2, null, 'Versorgungsverträge'),
    new KfmaoCode(6, 1, 2, 1, 'Fernwärmeverträge'),
    new KfmaoCode(6, 1, 2, 2, 'Netzanschlussverträge'),
    new KfmaoCode(6, 1, 2, 9, 'Sonstiges'),
    new KfmaoCode(6, 2, null, null, 'Betreiberunterlagen'),
    new KfmaoCode(6, 2, 12, null, 'Sonstiges'),
    new KfmaoCode(6, 2, 12, 1, 'Rauchmelder'),
    new KfmaoCode(6, 2, 3, null, 'Wärmeversorgungsanlagen  '),
    new KfmaoCode(6, 2, 3, 1, 'Heizkostenerfassungsgeräte'),
  ];

  private readonly contractNumberFilterName = 'Vertragsnummer';

  private readonly contractNumberStorageKey = 'contractNumber';

  private readonly documentTypeFilterName = 'Dokumententyp';

  private readonly documentTypeStorageKey = 'documentType';

  private readonly createdAtFilterName = 'Erstelldatum des Dokuments';

  private readonly createdAtStorageKey = 'createdAt';

  constructor(
    private http_: HttpClient,
    private filterClient_: FilterClient,
    private filterGroupClient: FiltergruppeClient
  ) {
    this.setsearchFilterEntities();
  }

  public setsearchFilterEntities() {
    this.http_
      .get<SearchFilterEntity[]>('assets/data/searchfilter-entities.json')
      .subscribe(res => {
        this.searchFilterSubject.next(res);
      });
  }

  /**
   * Concatenates the title and the description of the filter group, if given and sets it as the title
   * @param filtergruppe Filtergruppe, which contains the information for the title
   */
  updateTitle(filtergruppe: ApiFiltergruppe) {
    const newTitle: string = [filtergruppe.name, filtergruppe.beschreibung]
      .filter(x => x)
      .join(' ');

    this.title$.next(newTitle);
  }

  /**
   **
   * Observable endpoint for local search filter entity definition
   */
  api_get_data_search_entities(): Observable<SearchFilterEntity[]> {
    return this.http_.get<SearchFilterEntity[]>('assets/data/searchfilter-entities.json');
  }

  public updateSearchAttributes(params: Params) {
    this.queryParams = params;

    this.searchAttributes.forEach(attribute => {
      if (attribute.name) {
        // eslint-disable-next-line no-param-reassign
        attribute.vorbelegterWert = params[attribute.name.toLowerCase().replace(/\s/g, '')];
      }
    });
    this.set_search_attributes(this.searchAttributes);
  }

  public resetValues() {
    this.searchLocationId = '';
    this.queryParams = {};
  }

  public removeGefmaCodeFilterFromSearchAttributes(): void {
    this.removeFilterFromSearchAttributes('GEFMA Code');
  }

  public removeKfmaoCode1FilterFromSearchAttributes(): void {
    this.removeFilterFromSearchAttributes('KFM-Aktenordnung Ebene 1');
  }

  private removeFilterFromSearchAttributes(filterId: string): void {
    const hasFilter = this.searchAttributesInfo.some(x => x.name === filterId);
    if (hasFilter) {
      const removedElemens = this.searchAttributesInfo.splice(
        this.searchAttributesInfo.findIndex(x => x.name === filterId),
        1
      );

      removedElemens.forEach(x => {
        this.clear_input_field(x.id, x.name);
      });
    }
  }

  public addKfmaoCode1FilterToSearchAttributes(filterWertId: string): void {
    if (this.allApiFilter.length === 0) {
      return;
    }

    this.addSearchAttribute('KFM-Aktenordnung Ebene 1', filterWertId);
  }

  public addGefmaCodeFilterToSearchAttributes(filterWertId: string): void {
    if (this.allApiFilter.length === 0) {
      return;
    }

    this.addSearchAttribute('GEFMA Code', filterWertId);
  }

  private addSearchAttribute(filterName: string, filterWertId: string): void {
    const filter = this.allApiFilter.filter(apiFilter => apiFilter.name === filterName)[0];

    const filterWert = filter.werte.filter(apiFilterwert => apiFilterwert.id === filterWertId)[0];

    this.searchAttributesInfo.push({
      id: filter.id,
      name: filterWert.beschreibung,
      value: filterWert.text,
    } as SearchAttributeInfo);
  }

  /**
   * When the user selects a Filter Group (such as GEFMA or KFMAO) the frontend must take note
   * which filter group was selected by the user to make further API requests concerning which
   * Filter Group to search for.
   */
  set_selected_search_entity(id: string, filterWertId: string): void {
    this.searchFilterGroupIdSelected = id;
    this.gefmaOrKfmaoCodeSelected = filterWertId;
  }

  /**
   * Set the search attributes and their values for the search sidebar
   * @param response Array of search attributes
   */
  set_search_attributes(response: ApiFiltergruppenfilter[]): void {
    if (response.length === 0) {
      return;
    }

    this.searchAttributes = response;
    this.hiddenSearchAttributes = [];
    this.searchAttributesInfo = [];
    for (const attribute of response) {
      let attributeInfo: SearchAttributeInfo | undefined;

      if (attribute.name === 'GEFMA Code' && this.gefmaOrKfmaoCodeSelected !== '') {
        const gefmaCodeFilter = this.allApiFilter.find(x => x.name === 'GEFMA Code');

        const vorbelegterFilterWert = gefmaCodeFilter?.werte.find(
          x => x.id === this.gefmaOrKfmaoCodeSelected
        );

        attributeInfo = {
          id: attribute.id,
          name: attribute.name,
          value: vorbelegterFilterWert?.text,
        } as SearchAttributeInfo;
      } else if (
        attribute.name === 'KFM-Aktenordnung Ebene 1' &&
        this.gefmaOrKfmaoCodeSelected !== ''
      ) {
        const kfmaoFilter = this.allApiFilter.find(x => x.name === 'KFM-Aktenordnung Ebene 1');

        const vorbelegterFilterWert = kfmaoFilter?.werte.find(
          x => x.id === this.gefmaOrKfmaoCodeSelected
        );

        attributeInfo = {
          id: attribute.id,
          name: attribute.name,
          value: vorbelegterFilterWert?.text,
        } as SearchAttributeInfo;
      } else {
        attributeInfo = {
          id: attribute.id,
          name: attribute.name,
          value: attribute.vorbelegterWert,
        } as SearchAttributeInfo;
      }

      if (attribute.name) {
        if (attribute.name === this.contractNumberFilterName) {
          this.restoreValueFromSessionStorage(this.contractNumberStorageKey, attributeInfo);
        }

        if (attribute.name === this.documentTypeFilterName) {
          this.restoreValueFromSessionStorage(this.documentTypeStorageKey, attributeInfo);
        }

        if (attribute.name === this.createdAtFilterName) {
          this.restoreValueFromSessionStorage(this.createdAtStorageKey, attributeInfo);
        }

        attributeInfo.value =
          this.queryParams[attribute.name.toLowerCase().replace(/\s/g, '')] ?? attributeInfo.value;
      }

      this.searchAttributesInfo.push(attributeInfo);
    }

    if (Object.keys(this.queryParams).length > 0) {
      // hidden filters
      this.allApiFilter
        .filter(
          x =>
            this.searchAttributes.findIndex(y => y.id === x.id) === -1 &&
            this.queryParams[x.name.toLowerCase().replace(/\s/g, '')]
        )
        .forEach(searchAttribute => {
          const attributeInfo = {
            id: searchAttribute.id,
            name: searchAttribute.name,
            value: this.queryParams[searchAttribute.name.toLowerCase().replace(/\s/g, '')],
          } as SearchAttributeInfo;

          this.hiddenSearchAttributes.push(attributeInfo);
        });

      if (this.queryParams.wirtschaftseinheit && this.queryParams.wirtschaftseinheit !== '') {
        this.weParamSubject.next(this.queryParams.wirtschaftseinheit);
      }

      if (this.queryParams.tp) {
        let index = -1;
        if (this.queryParams.tp.toLowerCase().includes('ge')) {
          index = this.allApiFilter.findIndex(x => x.beschreibung.includes('TP (Gebäude)'));
        } else {
          index = this.allApiFilter.findIndex(x =>
            x.beschreibung.includes('TP (Adresse/Grundstück)')
          );
        }

        this.hiddenSearchAttributes.push({
          id: this.allApiFilter[index].id,
          name: this.allApiFilter[index].name,
          value: this.queryParams.tp,
        } as SearchAttributeInfo);
      }

      this.startSearch.next(true);
    }
  }

  public addTemporarySearchAttribute(filter: ApiFiltergruppenfilter) {
    if (!filter || !filter.id) {
      return;
    }

    this.searchAttributes = [...this.searchAttributes, filter];
    this.searchAttributesInfo.push({
      id: filter.id,
      name: filter.name,
      value: '',
    } as SearchAttributeInfo);
  }

  /**
   * Loads up all search filter attributes and their types in an array property
   * {id: "guid", name: "auftragnummer/dokumententyp", typ: 0 (Text)}
   */
  load_search_attributes_filter_properties(): void {
    this.subscriptions.push(
      this.filterClient_.get().subscribe(
        (response: ApiFilter[]) => {
          this.allApiFilter = response;
        },
        (error: any) => {
          console.error(error);
        }
      )
    );
  }

  loadFilterGroups(): void {
    this.subscriptions.push(
      this.filterGroupClient.getAll().subscribe(
        (response: ApiFiltergruppe[]) => {
          this.allApiFiltergruppenSubject.next(response);
        },
        (error: any) => {
          console.error(error);
        }
      )
    );
  }

  /**
   * Terminates all ongoing Observables subscriptions as a good practice (useful for ngDestroy).
   * @param subscriptions Array of Subscriptions to terminate. If not provided, will terminate subscriptions of dashboard service
   */
  terminate_all_subscriptions(subscriptions?: Subscription[]): void {
    if (subscriptions != undefined) {
      for (const subscription of subscriptions) {
        subscription.unsubscribe();
      }
    } else {
      this.terminate_all_subscriptions(this.subscriptions);
    }
  }

  /**
   * Reads what type a search attribute is (Text, int, float, select, date...)
   * @param id ID of search attribute (looking up the search attributes array property)
   * @returns Attribute Type (e.g. 0 = Text, 1 = int and so on) for rendering the corresponding
   * input fields. -1 for Type not found.
   */
  read_attribute_type_of_id(id: string): number {
    for (const attribute of this.allApiFilter) {
      if (attribute.id === id) {
        return attribute.typ;
      }
    }
    return -1;
  }

  // FORM FUNCTIONS

  /**
   * Clears the input field
   * @param field_id ID of Search Attribute to clear
   * @param filterName Name of the Filter, that is cleared
   */
  clear_input_field(field_id: string | undefined, filterName: string): void {
    let counter = 0;
    for (const attribute of this.searchAttributesInfo) {
      if (attribute.id === field_id) {
        attribute.value = undefined;
        let index = counter;
        if (index < this.searchAttributesInfo.length) {
          for (let i = index + 1; i <= this.searchAttributesInfo.length; i++) {
            if (filterName.startsWith('KFM-Aktenordnung Ebene')) {
              this.searchAttributesInfo[i].disabled = true;
            }
          }
          index += 1;
        }
      }
      counter += 1;
    }

    if (filterName === this.contractNumberFilterName) {
      sessionStorage.removeItem(this.contractNumberStorageKey);
    } else if (filterName === this.documentTypeFilterName) {
      sessionStorage.removeItem(this.documentTypeStorageKey);
    } else if (filterName === this.createdAtFilterName) {
      sessionStorage.removeItem(this.createdAtStorageKey);
    }
  }

  /**
   * Clears all input fields
   */
  public clearAllInputFields(): void {
    for (const attribute of this.searchAttributesInfo) {
      attribute.value = undefined;
    }

    sessionStorage.removeItem(this.createdAtStorageKey);
    sessionStorage.removeItem(this.documentTypeStorageKey);
    sessionStorage.removeItem(this.contractNumberStorageKey);
  }

  /**
   * Tries to load a value from the session storage and if successfull, it is written into the attribute
   * infos value property.
   * @param storageKey The key the value is stored in the session storage.
   * @param attributeInfo The attribute info object, which is the target for the restored value.
   */
  private restoreValueFromSessionStorage(storageKey: string, attributeInfo: SearchAttributeInfo) {
    const restoredValue = sessionStorage.getItem(storageKey);
    if (restoredValue && restoredValue !== '') {
      if (storageKey === this.createdAtStorageKey) {
        attributeInfo.value = new Date(restoredValue);
      } else {
        attributeInfo.value = restoredValue;
      }
    }
  }
}
